var render = function (_h,_vm) {var _c=_vm._c;return _c('button',{staticClass:"button-rs",class:_vm.props.classes,on:{"click":_vm.listeners.click}},[_c('i',{class:[_vm.props.iconClass, _vm.props.icon]}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }